import Request from './Request';

class AdminMenuRequest extends Request {
  async getMenu() {
    let url = '/admin/menu/list';
    return await this.get(url);
  }
}
export default AdminMenuRequest.getInstance()